import { hasPermission } from 'Vulture/Permissions.js';

// Canonical navigation definitions: the single source of truth for BOTH the sidebar
// (which entries render) AND the account-switch access guard in Vulture/Form/Login/App.js
// (redirect away from a view the user can't access in a newly selected account). Every
// routable, permission-gated dashboard mode must appear here so the two stay in sync.

// Base items available to all roles (subject to their `permission`).
export const SIDEBAR_ITEMS = [
	{ name: 'systems',             label: 'Hierarchy',            icon: 'sitemap',                  permission: 'property_access' },
	{ name: 'content',             label: 'Content',              icon: 'th-list',                  permission: 'property_access' },
	{ name: 'library',             label: 'Library',              icon: 'book',                     permission: 'property_access' },
	{ name: 'slide_deck',          label: 'Slide Deck',           icon: 'clone',                    permission: 'vcl_view' },
	{ name: 'visual_content_loop', label: 'Visual Content Loop',  icon: 'visual_content_loop_icon', permission: 'vcl_view' },
	{ name: 'proof_of_play',       label: 'Proof of Play',        icon: 'chart-line',               permission: 'pop_analytics' },
];

// Admin / settings items.
export const ADMIN_ITEMS = [
	{ name: 'account_settings',      label: 'Settings',    icon: 'cog',         permission: 'settings_access' },
	{ name: 'ai_generation_dashboard', label: 'AI Dashboard', icon: 'robot',     permission: 'tools_access' },
	{ name: 'system_programming',    label: 'Programming', icon: 'layer-group', permission: 'programming' },
	{ name: 'userAdmin',             label: 'Users',       icon: 'users',       permission: 'user_view' },
	{ name: 'role_management',       label: 'Roles',       icon: 'user-shield', permission: 'user_management' },
];

// modePermission returns the permission gating a mode, or null for ungated modes
// (login, accounts landing, user_profile, billing, folder_navigation, …).
export const modePermission = (mode) => {
	const item = [...SIDEBAR_ITEMS, ...ADMIN_ITEMS].find((i) => i.name === mode);
	return item ? item.permission : null;
};

// canAccessMode reports whether the current user may view `mode`. Ungated modes are
// always accessible. Used to redirect a user off a gated page when they switch to an
// account where they lack that page's permission.
export const canAccessMode = (mode) => {
	const perm = modePermission(mode);
	return !perm || hasPermission(perm);
};
